/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var fetchurl = window.Shopify.routes.root + 'cart.json';

fetch(fetchurl)
  .then(function(response) {
    // Check if the request was successful
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    // Parse the response as JSON or text, depending on your needs
    return response.json(); // or response.text() for plain text
  })
  .then(function(data) {
    // Handle the data
    console.log(data);
  })
  .catch(function(error) {
    // Handle errors
    console.error('Fetch error:', error);
  });

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  console.log(variant)
});


const checkSVG = '<svg focusable="false" class="icon icon--store-availability-in-stock " viewBox="0 0 18 14" role="presentation"><path d="M2 6l5 5 9-9" stroke="#00C200" stroke-width="3" fill="none"></path></svg>'
const exSVG = '<svg focusable="false" class="icon icon--store-availability-out-of-stock " viewBox="0 0 18 14" fill="none" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 10l-2 2-4-4-4 4-2-2 4-4-4-4 2-2 4 4 4-4 2 2-4 4 4 4z" fill="#FD1A20"></path></svg>'
const plusSVG = '<svg focusable="false" class="icon icon--plus " viewBox="0 0 10 10" role="presentation"><path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fill-rule="evenodd"></path></svg>'
const minusSVG = '<svg focusable="false" class="icon icon--minus " viewBox="0 0 10 2" role="presentation"><path d="M10 0v2H0V0z" fill="currentColor"></path></svg>'
const loader = '<svg focusable="false" class="icon icon--search-loader " viewBox="0 0 64 64" role="presentation"><path opacity=".4" d="M23.8589104 1.05290547C40.92335108-3.43614731 58.45816642 6.79494359 62.94709453 23.8589104c4.48905278 17.06444068-5.74156424 34.59913135-22.80600493 39.08818413S5.54195825 57.2055303 1.05290547 40.1410896C-3.43602265 23.0771228 6.7944697 5.54195825 23.8589104 1.05290547zM38.6146353 57.1445143c13.8647142-3.64731754 22.17719655-17.89443541 18.529879-31.75914961-3.64743965-13.86517841-17.8944354-22.17719655-31.7591496-18.529879S3.20804604 24.7494569 6.8554857 38.6146353c3.64731753 13.8647142 17.8944354 22.17719655 31.7591496 18.529879z"></path><path d="M1.05290547 40.1410896l5.80258022-1.5264543c3.64731754 13.8647142 17.89443541 22.17719655 31.75914961 18.529879l1.5264543 5.80258023C23.07664892 67.43614731 5.54195825 57.2055303 1.05290547 40.1410896z"></path></svg>'



var my_store = localStorage.getItem('my_store')
if (my_store === null | my_store === undefined | my_store === '' | isNaN(my_store)) {
  my_store = 'warehouse'
}

var inventory_levels = localStorage.getItem('first_variant_inventory')
inventory_levels = JSON.parse(inventory_levels)
var itemInventoryLocales = localStorage.getItem('itemInventoryLocales')
itemInventoryLocales = JSON.parse(itemInventoryLocales)
var locations = localStorage.getItem('locations')
locations = JSON.parse(locations)

if (locations) {
  for (let i = 0; i < locations.length; i++) {
    var locationID = locations[i]["Location ID"]
    if (locationID.replaceAll(" ", "").includes(my_store.replaceAll(" ", ""))) {
      var my_storeName = locations[i]["Name"]
    }
  }


  var buyNowButtons = document.getElementsByName("product-buy-buttons")
  var buyNowButtonsATC = document.getElementById("product-buy-buttons--add_to_cart")
  var buyNowButtonsPO = document.getElementById("product-buy-buttons--pre_order")
  var buyNowButtonsCO = document.getElementById("product-buy-buttons--custom_order")
  var buyNowButtonsSO = document.getElementById("product-buy-buttons--sold_out")


  // sets inital item attributs selectors

  var variantContainer = document.getElementsByClassName('product-form__variants')[0]
  var initalItemProperties = localStorage.getItem('initalItemProperties')
  if (initalItemProperties) {
    initalItemProperties = JSON.parse(initalItemProperties)

    var customDiv = document.createElement('div')
    customDiv.classList.add('custom--options')

    for (let i = 0; i < initalItemProperties.length; i++) {
      var mainDiv = document.createElement('div')
      mainDiv.classList.add('product-form__option')
      mainDiv.id = `custom--option--${initalItemProperties[i]['Title']}`
      var optionTitle = document.createElement('span')
      optionTitle.classList.add('product-form__option-name')
      optionTitle.classList.add('text--strong')
      title = initalItemProperties[i]['Title']
      optionTitle.innerHTML = title + ":"
      var selectedOption = document.createElement('span')
      selectedOption.classList.add('product-form__selected-value')
      selectedOption.innerHTML = ''
      optionTitle.appendChild(selectedOption)
      mainDiv.appendChild(optionTitle)
      if (initalItemProperties[i]['Type'] == 'Block Selector') {
        var blockContainer = document.createElement('div')
        blockContainer.classList.add('block-swatch-list')
        var blocks = initalItemProperties[i]['Blocks']
        for (let x in blocks) {
          var blockDiv = document.createElement('div')
          blockDiv.classList.add('block-swatch')
          blockDiv.innerHTML = `<input required class="block-swatch__radio product-form__single-selector" data-option-position="4" type="radio" id="${title}-${x}" name="properties[${title}]" value="${x}"> <label class="block-swatch__item" for="${title}-${x}">${x}</label>`
          blockContainer.appendChild(blockDiv)
        }
        mainDiv.appendChild(blockContainer)
      } else if (initalItemProperties[i]['Type'] == 'Color') {
        var blockContainer = document.createElement('div')
        blockContainer.classList.add('color-swatch-list--large')
        blockContainer.classList.add('color-swatch-list')
        var blocks = initalItemProperties[i]['Colors']
        for (let x in blocks) {
          var blockDiv = document.createElement('div')
          blockDiv.classList.add('color-swatch')
          if (x === 'White') {
            if (initalItemProperties[i]['SVG']) {
              blockDiv.innerHTML = `<input required class="color-swatch__radio product-form__single-selector" data-option-position="5" type="radio" id="${title}-${x}" name="properties[${title}]" value="${x}"> <label class="color-swatch--white color-swatch__item" aria-label="${x}" onclick="changeSVGColor('${initalItemProperties[i]['SVG']}','#${blocks[x]}')" style="background-color: #${blocks[x]}" for="${title}-${x}"></label>`
            } else {
              blockDiv.innerHTML = `<input required class="color-swatch__radio product-form__single-selector" data-option-position="5" type="radio" id="${title}-${x}" name="properties[${title}]" value="${x}"> <label class="color-swatch--white color-swatch__item" aria-label="${x}" style="background-color: #${blocks[x]}" for="${title}-${x}"></label>`
            }
          } else if (blocks[x].includes('IMG')) {
            var imgURL = blocks[x].replace("IMG", "url")
            blockDiv.innerHTML = `<input required class="color-swatch__radio product-form__single-selector" data-option-position="5" type="radio" id="${title}-${x}" name="properties[${title}]" value="${x}"> <label class="color-swatch__item" aria-label="${x}" style="width:100px;height:100px;background-image: ${imgURL}" for="${title}-${x}"></label>`
          } else {
            if (initalItemProperties[i]['SVG']) {
              blockDiv.innerHTML = `<input required class="color-swatch__radio product-form__single-selector" data-option-position="5" type="radio" id="${title}-${x}" name="properties[${title}]" value="${x}"> <label class="color-swatch__item" aria-label="${x}" onclick="changeSVGColor('${initalItemProperties[i]['SVG']}','#${blocks[x]}')" style="background-color: #${blocks[x]}" for="${title}-${x}"></label>`
            } else {
              blockDiv.innerHTML = `<input required class="color-swatch__radio product-form__single-selector" data-option-position="5" type="radio" id="${title}-${x}" name="properties[${title}]" value="${x}"> <label class="color-swatch__item" aria-label="${x}" style="background-color: #${blocks[x]}" for="${title}-${x}"></label>`
            }
          }
          blockContainer.appendChild(blockDiv)
        }
        mainDiv.appendChild(blockContainer)
      }
      customDiv.appendChild(mainDiv)
    }

    if (variantContainer) {
      variantContainer.appendChild(customDiv)
    }

  }

  // set inital product info table

  var tableProductSpecs = document.getElementById("product-specs-tbody")
  if (tableProductSpecs) {
    tableProductSpecs.innerHTML = ''
    var jsonSpecs = localStorage.getItem('firstVariantMetafields')
    jsonSpecs = JSON.parse(jsonSpecs)
    var customOrder = jsonSpecs['*Processing Time']
    var preOrder = jsonSpecs['*Pre Order']
    var releaseDate = jsonSpecs['*Release Date']
    for (let x in jsonSpecs) {
      if (typeof jsonSpecs[x] === 'object') {
        var jsonTwo = jsonSpecs[x]
        for (let y in jsonTwo) {
          if (jsonTwo[y] && !y.includes('*')) {
            var row = tableProductSpecs.insertRow()
            row.insertCell(0).innerHTML = y
            row.insertCell(1).innerHTML = jsonTwo[y]
          }
        }
      } else {
        if (jsonSpecs[x] && !x.includes('*')) {
          var row = tableProductSpecs.insertRow()
          row.insertCell(0).innerHTML = x
          row.insertCell(1).innerHTML = jsonSpecs[x]
        }
      }
    }
    var tableChildren = tableProductSpecs.children
    for (let i in tableChildren) {
      var rowsChildren = tableChildren[i]
      var tds = rowsChildren.children
      if (tds !== undefined) {
        tds = tds[0]
      }
      var rowChildren = tds
      if (rowChildren) {
        rowChildren.classList.add("heading")
        rowChildren.classList.add("table-heading")
      }
    }
  }
  // set availability on product page ***inital***
  var iconInsert = document.getElementById("availabilitIcon")
  var storeNameInsert = document.getElementById("availabilitStoreName")
  if (inventory_levels) {
    if (preOrder === true) {
      if (iconInsert && buyNowButtonsPO) {
        iconInsert.innerHTML = checkSVG
        buyNowButtonsPO.style.display = 'block'
      }
    } else if (customOrder !== '') {
      if (iconInsert && buyNowButtonsCO) {
        iconInsert.innerHTML = checkSVG
        buyNowButtonsCO.style.display = 'block'
      }
    } else if (inventory_levels[my_store] > 0) {
      if (iconInsert && buyNowButtonsATC) {
        iconInsert.innerHTML = checkSVG
        buyNowButtonsATC.style.display = 'block'
      }
    } else {
      if (iconInsert && buyNowButtonsSO) {
        iconInsert.innerHTML = exSVG
        buyNowButtonsSO.style.display = 'block'
      }
    }
    if (my_store === 'warehouse') {
      if (storeNameInsert) {
        if (preOrder === true) {
          storeNameInsert.innerHTML = itemInventoryLocales['pre_order']
        } else if (customOrder !== '') {
          storeNameInsert.innerHTML = itemInventoryLocales['custom_order']
        } else {
          storeNameInsert.innerHTML = itemInventoryLocales['delivery']
        }
      }
    } else {
      if (storeNameInsert) {
        if (preOrder === true) {
          storeNameInsert.innerHTML = itemInventoryLocales['pre_order']
        } else if (customOrder !== '') {
          storeNameInsert.innerHTML = itemInventoryLocales['custom_order']
        } else {
          storeNameInsert.innerHTML = itemInventoryLocales['pickup_at'] + " " + my_storeName
        }
      }
    }
    //Expected Arrival PO DATE
    if(jsonSpecs){
      setExpectedDate(jsonSpecs['SKU'], `expectedDelivery`, inventory_levels[my_store], 'page')
    }
  }

  function onModalOpenInventory() {
    var iconInsert = document.getElementById("availabilitIcon")
    var storeNameInsert = document.getElementById("availabilitStoreName")
    if (inventory_levels[my_store] > 0 && buyNowButtonsATC) {
      iconInsert.innerHTML = checkSVG
      buyNowButtonsATC.style.display = 'block'
    } else if (buyNowButtonsSO) {
      iconInsert.innerHTML = exSVG
      buyNowButtonsSO.style.display = 'block'
    }
    if (my_store === 'warehouse') {
      storeNameInsert.innerHTML = itemInventoryLocales['delivery']
    } else {
      storeNameInsert.innerHTML = itemInventoryLocales['pickup_at'] + " " + my_storeName
    }
  }

  function switchVariant(x, y, z) {

    //redefine variant title if more than one option
    var variantOptionsCount = parseInt(z)
    if (variantOptionsCount > 1) {
      var options = document.getElementsByClassName('product-form__option-name text--strong')
      var variantTitle = ''
      for (let i = 0; i < options.length; i++) {
        var optionText = (options[i].innerText).split(': ')
        var optionName = optionText[0]
        var optionValue = optionText[1]
        if (optionValue !== undefined) {
          if (optionName === y) {
            variantTitle = variantTitle + "|" + x
          } else {
            variantTitle = variantTitle + "|" + optionValue
          }
        }
      }
      variantTitle = variantTitle.replace("|", "").toLowerCase().replaceAll("|", "-").replaceAll(" ", "-").replaceAll(".", "-").replaceAll("(", "").replaceAll(")", "").replaceAll('"', '')
      x = variantTitle
    }

    var jsonSpecs = localStorage.getItem('variantMetafieldsData')
    jsonSpecs = JSON.parse(jsonSpecs)
    var jsonSpecs = jsonSpecs[x]

    //handles Price Change


    //handles Store Availability


    //handles Buy Buttons change


    //handles Vendor change 


    //handles product spec change

    //handles manufacting info change
    var manuInfo = jsonSpecs['*Manufacturing Info']
    var warningContainer = document.getElementById('warningContainer')
    var warningAlertText = document.getElementById('warningAlertText')
    var warningText = document.getElementById('warningText')

    if (warningContainer) {
      if (manuInfo) {
        warningText.innerHTML = manuInfo
        if (warningContainer.style.display === 'none') {
          warningContainer.style.display = 'block'
        }
      } else {
        if (warningContainer.style.display === 'block') {
          warningContainer.style.display = 'none'
        }
      }
    }


    var tableProductSpecs = document.getElementById("product-specs-tbody")
    tableProductSpecs.innerHTML = ''
    if (tableProductSpecs) {
      if (document.getElementById("case-size")) {
        document.getElementById("case-size").value = jsonSpecs['*Case Size']
        if (document.getElementById("teir1")) {
          document.getElementById("teir1").innerText = (parseInt(jsonSpecs['*Case Size']) * 1) + "+"
          document.getElementById("teir2").innerText = (parseInt(jsonSpecs['*Case Size']) * 2) + "+"
          document.getElementById("teir3").innerText = (parseInt(jsonSpecs['*Case Size']) * 3) + "+"
        }
      }
      for (let z in jsonSpecs) {
        if (typeof jsonSpecs[z] === 'object') {
          var jsonTwo = jsonSpecs[z]
          for (let y in jsonTwo) {
            if (jsonTwo[y] && !y.includes('*')) {
              var row = tableProductSpecs.insertRow()
              row.insertCell(0).innerHTML = `<span class="heading table--heading">${y}</span>`;
              row.insertCell(1).innerHTML = `<span class="table--info">${jsonTwo[y]}</span>`;
            }
          }
        } else {
          if (jsonSpecs[z] && !z.includes('*')) {
            var row = tableProductSpecs.insertRow()
            row.insertCell(0).innerHTML = `<span class="heading table--heading">${z}</span>`;
            row.insertCell(1).innerHTML = `<span class="table--info">${jsonSpecs[z]}</span>`;
          }
        }
      }
      var tableChildren = tableProductSpecs.children
      for (let i in tableChildren) {
        var rowsChildren = tableChildren[i]
        var tds = rowsChildren.children
        if (tds !== undefined) {
          tds = tds[0]
        }
        var rowChildren = tds
        if (rowChildren) {
          rowChildren.classList.add("heading")
          rowChildren.classList.add("table-heading")
        }
      }
    }

    // handles bulk buy change

    var customOrder = jsonSpecs['*Processing Time']
    var releaseDate = jsonSpecs['*Release Date']
    var preOrder = jsonSpecs['*Pre Order']
    var customOrderPreInfo = document.getElementById('customOrderPreInfo')

    var deals = jsonSpecs['*Deal']

    var badgeSpecialContainer = document.getElementById(`product-labels`)
    var badgeDisc = document.getElementById(`product-labels-disc`)
    var badgeClear = document.getElementById(`product-labels-clear`)
    var badgeLimted = document.getElementById(`product-labels-limted`)
    var discLabel = itemInventoryLocales['discontinued']
    var clearLabel = itemInventoryLocales['clearance']
    var limtedLabel = itemInventoryLocales['limited']


    //handles badge change (discontinued/clearance etc.)
    if (deals.includes('Discontinued')) {//look at deals and add the appropriate badge
      if (!badgeDisc) {
        var DiscBadge = document.createElement('span')
        DiscBadge.classList.add('product-label')
        DiscBadge.classList.add('product-label--custom2')
        DiscBadge.id = `product-labels-disc`
        DiscBadge.innerText = discLabel
        badgeSpecialContainer.appendChild(DiscBadge)
      }
    } else if (deals.includes('Clearance')) {
      if (!badgeClear) {
        var ClearBadge = document.createElement('span')
        ClearBadge.classList.add('product-label')
        ClearBadge.classList.add('product-label--custom3')
        ClearBadge.id = `product-labels-clear`
        ClearBadge.innerText = clearLabel
        badgeSpecialContainer.appendChild(ClearBadge)
      }
    } else if (deals.includes('Limited')) {
      if (!badgeLimted) {
        var LimtedBadge = document.createElement('span')
        LimtedBadge.classList.add('product-label')
        LimtedBadge.classList.add('product-label--custom4')
        LimtedBadge.id = `product-labels-limted`
        LimtedBadge.innerText = limtedLabel
        badgeSpecialContainer.appendChild(LimtedBadge)
      }
    } else {
      if (document.getElementById(`product-labels-disc`)) {
        document.getElementById(`product-labels-disc`).remove()
      }
      if (document.getElementById(`product-labels-clear`)) {
        document.getElementById(`product-labels-clear`).remove()
      }
      if (document.getElementById(`product-labels-limted`)) {
        document.getElementById(`product-labels-limted`).remove()
      }

    }

    var inventoryData = localStorage.getItem('inventoryData')
    inventoryData = JSON.parse(inventoryData)
    for (let i = 0; i < buyNowButtons.length; i++) {
      buyNowButtons[i].style.display = "none"
    }
    if (preOrder === true && buyNowButtonsPO) {
      iconInsert.innerHTML = checkSVG
      buyNowButtonsPO.style.display = 'block'
      customOrderPreInfo.innerText = releaseDate
    } else if (customOrder !== '' && buyNowButtonsCO) {
      iconInsert.innerHTML = checkSVG
      buyNowButtonsCO.style.display = 'block'
      customOrderPreInfo.innerText = customOrder
    } else if (inventoryData[x][my_store] > 0 && buyNowButtonsATC) {
      iconInsert.innerHTML = checkSVG
      buyNowButtonsATC.style.display = 'block'
      customOrderPreInfo.innerText = ''
    } else if (buyNowButtonsSO) {
      iconInsert.innerHTML = exSVG
      buyNowButtonsSO.style.display = 'block'
      customOrderPreInfo.innerText = ''
    }
    if (my_store === 'warehouse' && storeNameInsert) {
      if (preOrder === true) {
        storeNameInsert.innerHTML = itemInventoryLocales['pre_order']
      } else if (customOrder !== '') {
        storeNameInsert.innerHTML = itemInventoryLocales['custom_order']
      } else {
        storeNameInsert.innerHTML = itemInventoryLocales['delivery']
      }
    } else if (storeNameInsert) {
      if (preOrder === true) {
        storeNameInsert.innerHTML = itemInventoryLocales['pre_order']
      } else if (customOrder !== '') {
        storeNameInsert.innerHTML = itemInventoryLocales['custom_order']
      } else {
        storeNameInsert.innerHTML = itemInventoryLocales['pickup_at'] + " " + my_storeName
      }
    }

    //Expected Arrival PO DATE
    //setExpectedDate(jsonSpecs['SKU'], `expectedDelivery`, inventoryData[x][my_store], 'page')


    var jsonIngHowData = localStorage.getItem('jsonIngHowData')
    jsonIngHowData = JSON.parse(jsonIngHowData)
    jsonIngHowData = jsonIngHowData[x]
    //handles ingredients
    var ingredients = jsonIngHowData['Ingredients']
    var ingredientsDiv = document.getElementById("ingredients")
    var ingredientsInsert = document.getElementById("ingredientsText")
    if (ingredients !== '' && ingredientsDiv) {
      if (ingredientsDiv.style.display = 'block') {
        ingredientsInsert.innerHTML = ingredients
      } else {
        ingredientsDiv.style.display = 'block'
        ingredientsInsert.innerHTML = ingredients
      }
    } else if (ingredientsDiv) {
      if (ingredientsDiv.style.display = 'block') {
        ingredientsDiv.style.display = 'none'
      }
    }

    //handles how_to_use
    var how_to_use = jsonIngHowData['How to use']
    var how_to_useDiv = document.getElementById("how_to_use")
    var how_to_useInsert = document.getElementById("how_to_useText")
    if (how_to_use !== '' && how_to_useDiv) {
      if (how_to_useDiv.style.display = 'block') {
        how_to_useInsert.innerHTML = how_to_use
      } else {
        how_to_useDiv.style.display = 'block'
        how_to_useInsert.innerHTML = how_to_use
      }
    } else if (how_to_useDiv) {
      if (how_to_useDiv.style.display = 'block') {
        how_to_useDiv.style.display = 'none'
      }
    }

    // handles buy now id change

    var buyNowButton = document.getElementById('buy_now')
    if (buyNowButton) {
      buyNowButton.name = jsonSpecs['*Catalog #']
    }

    //handles properties change
    var oldDivs = document.getElementsByClassName('custom--options')[0]
    if (oldDivs) {
      oldDivs.remove()
    }
    var allPropertiesJSON = localStorage.getItem('allItemProperties')
    if (allPropertiesJSON) {
      var propertiesData = JSON.parse(allPropertiesJSON)
      propertiesData = propertiesData[x]
    }

    var variantContainer = document.getElementsByClassName('product-form__variants')[0]
    if (propertiesData) {

      var customDiv = document.createElement('div')
      customDiv.classList.add('custom--options')

      for (let i = 0; i < propertiesData.length; i++) {
        var mainDiv = document.createElement('div')
        mainDiv.classList.add('product-form__option')
        mainDiv.id = `custom--option--${propertiesData[i]['Title']}`
        var optionTitle = document.createElement('span')
        optionTitle.classList.add('product-form__option-name')
        optionTitle.classList.add('text--strong')
        title = propertiesData[i]['Title']
        optionTitle.innerHTML = title + ":"
        var selectedOption = document.createElement('span')
        selectedOption.classList.add('product-form__selected-value')
        selectedOption.innerHTML = ''
        optionTitle.appendChild(selectedOption)
        mainDiv.appendChild(optionTitle)
        if (propertiesData[i]['Type'] == 'Block Selector') {
          var blockContainer = document.createElement('div')
          blockContainer.classList.add('block-swatch-list')
          var blocks = propertiesData[i]['Blocks']
          for (let x in blocks) {
            var blockDiv = document.createElement('div')
            blockDiv.classList.add('block-swatch')
            blockDiv.innerHTML = `<input required class="block-swatch__radio product-form__single-selector" data-option-position="4" type="radio" id="${title}-${x}" name="properties[${title}]" value="${x}"> <label class="block-swatch__item" for="${title}-${x}">${x}</label>`
            blockContainer.appendChild(blockDiv)
          }
          mainDiv.appendChild(blockContainer)
        } else if (propertiesData[i]['Type'] == 'Color') {
          var blockContainer = document.createElement('div')
          blockContainer.classList.add('color-swatch-list--large')
          blockContainer.classList.add('color-swatch-list')
          var blocks = propertiesData[i]['Colors']
          for (let x in blocks) {
            var blockDiv = document.createElement('div')
            blockDiv.classList.add('color-swatch')
            if (x === 'White') {
              if (propertiesData[i]['SVG']) {
                blockDiv.innerHTML = `<input required class="color-swatch__radio product-form__single-selector" data-option-position="5" type="radio" id="${title}-${x}" name="properties[${title}]" value="${x}"> <label class="color-swatch--white color-swatch__item" aria-label="${x}" onclick="changeSVGColor('${propertiesData[i]['SVG']}','#${blocks[x]}')" style="background-color: #${blocks[x]}" for="${title}-${x}"></label>`
              } else {
                blockDiv.innerHTML = `<input required class="color-swatch__radio product-form__single-selector" data-option-position="5" type="radio" id="${title}-${x}" name="properties[${title}]" value="${x}"> <label class="color-swatch--white color-swatch__item" aria-label="${x}" style="background-color: #${blocks[x]}" for="${title}-${x}"></label>`
              }
            } else if (blocks[x].includes('IMG')) {
              var imgURL = blocks[x].replace("IMG", "url")
              blockDiv.innerHTML = `<input required class="color-swatch__radio product-form__single-selector" data-option-position="5" type="radio" id="${title}-${x}" name="properties[${title}]" value="${x}"> <label class="color-swatch__item" aria-label="${x}" style="width:100px;height:100px;background-image: ${imgURL}" for="${title}-${x}"></label>`
            } else {
              if (propertiesData[i]['SVG']) {
                blockDiv.innerHTML = `<input required class="color-swatch__radio product-form__single-selector" data-option-position="5" type="radio" id="${title}-${x}" name="properties[${title}]" value="${x}"> <label class="color-swatch__item" aria-label="${x}" onclick="changeSVGColor('${propertiesData[i]['SVG']}','#${blocks[x]}')" style="background-color: #${blocks[x]}" for="${title}-${x}"></label>`
              } else {
                blockDiv.innerHTML = `<input required class="color-swatch__radio product-form__single-selector" data-option-position="5" type="radio" id="${title}-${x}" name="properties[${title}]" value="${x}"> <label class="color-swatch__item" aria-label="${x}" style="background-color: #${blocks[x]}" for="${title}-${x}"></label>`
              }
            }
            blockContainer.appendChild(blockDiv)
          }
          mainDiv.appendChild(blockContainer)
        }
        customDiv.appendChild(mainDiv)
      }

      variantContainer.appendChild(customDiv)

    }

  }

console.log(window.Shopify.routes.root)
  function setStore(x, y) {
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', `attributes[my_store]=${x}`);
    var buttons = document.getElementsByName("store_selector")
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].innerHTML = `<div class="link" onclick="setStore('${x}')" style="cursor:pointer">Set as my preferred store</div>`
    }
    var button = document.getElementById(`store_selector--${x}`)
    button.innerHTML = `<div id="store_selector--${x}" name="store_selector">${checkSVG}My Store</div>`
    localStorage.setItem('my_store', x)
    if (y) {
      setTimeout(reloadP, 1000, y)
    } else {
      setTimeout(function () {
        window.location.reload();
      }, 1000);
    }
  };

}

function getCurrentURL() {
  return window.location.href
}

if(getCurrentURL().includes('cart')){
  console.log(window.Shopify)
}

const url = getCurrentURL()

function lanqRedirect(x) {
  if (url.includes('/fr')) {
    location.href = `/fr/${x}`
  } else {
    location.href = `/${x}`
  }
};

if (url.includes('/cart')) {
  initalCartLoad()
}

function switchCustomeritem(x, y) {
  if (x === null || x === undefined) {
    x = 'customerSelector--orders'
  }
  localStorage.setItem("customerDisplay", x)
  if (url.includes('account') && !url.includes('register') && !url.includes('recover')) {
    if (url.includes("page=") && y !== 'noRedirect') {
      lanqRedirect('account')
    } else {
      var customerAccountSection = document.getElementsByName("customerAccountSection")
      for (let i = 0; i < customerAccountSection.length; i++) {
        customerAccountSection[i].style.display = 'none'
      }
      var sectionID = document.getElementById(x.replace('customerSelector', 'customersAccount'))
      sectionID.style.display = 'block'
      var selectors = document.getElementsByName("customerSelector")
      for (let i = 0; i < selectors.length; i++) {
        selectors[i].classList.remove("is-selected")
        if (selectors[i].id === x) {
          selectors[i].classList.add("is-selected")
        }
      }
      var checkMark = document.getElementsByName("checkMark")
      for (let i = 0; i < checkMark.length; i++) {
        checkMark[i].style.display = 'none'
        if (checkMark[i].id === x) {
          checkMark[i].style.display = 'inline-block'
        }
      }
    }
  } else if (y === 'redirect') {
    lanqRedirect('account')
  }
  if (document.getElementById("accountloading")) {
    document.getElementById('accountloading').style.display = 'none'
  }
}

function variantItemChange(x, y, z) {

  localStorage.setItem(`collectionVariantID`, y)

  //set variables
  var variantID = y //variant id for getting proper data
  var productID = z //for getting the proper div in collection list

  var my_store = 'warehouse'
  if (localStorage.getItem('my_store')) {
    my_store = localStorage.getItem('my_store') //sets selected store id
  }

  var jsonData = JSON.parse(x) //sets json data
  var VariantJson = jsonData[variantID]
  var variantInventory = VariantJson['Inventory Details']
  var variantOther = VariantJson['Other Details']
  var variantDetails = VariantJson['Variant Details']

  var priceDiv = document.getElementById(`variantPrice--${productID}`)
  var comparePriceDiv = document.getElementById(`variantPrice-compare--${productID}`)
  var variantPrice = variantDetails['price']
  var variantComparedPrice = variantDetails['compare_at_price']

  var variantSavings = variantOther['Discount Label']
  var badgeContainer = document.getElementById(`product-labels--${productID}`)
  var badgeSale = document.getElementById(`product-labels-on-sale--${productID}`)

  var caseQty = variantOther['Case QTY']

  var badgeSpecialContainer = document.getElementById(`product-labels--special--${productID}`)
  var deals = variantOther['Deals']
  var badgeNew = document.getElementById(`-product-labels-new-${productID}`)
  var badgeDisc = document.getElementById(`product-labels-disc--${productID}`)
  var badgeClear = document.getElementById(`product-labels-clear--${productID}`)
  var badgeLimted = document.getElementById(`product-labels-limited--${productID}`)
  var newLabel = variantOther['New Badge']
  var discLabel = variantOther['Disc Badge']
  var clearLabel = variantOther['Clear Badge']
  var limtedLabel = variantOther['Limited Badge']

  var checkExDiv = document.getElementById(`availabilitIcon--${productID}`)
  var storeNameDiv = document.getElementById(`availabilitStoreName--${productID}`)
  var customOrderPreInfo = document.getElementById(`customOrderPreInfo--${productID}`)
  var variantInventoryNumber = variantInventory[my_store]

  //Expected Arrival PO DATE
  setExpectedDate(VariantJson['Variant Details']['sku'], `expectedDelivery--${productID}`, variantInventoryNumber)

  var buyButton = document.getElementById(`product-buy-buttons--${productID}`)

  var CustomOrderLabel = variantOther['Custom Order Label']
  var CustomPreLabel = variantOther['Pre-Order Label']
  var AddToCartLabel = variantOther['Add To Cart Label']
  var SoldOutLabel = variantOther['Sold Out Label']
  var CustomOrder = variantOther['Custom Order']
  var PreOrder = variantOther['Pre-Order']
  var CustomOrderText = variantOther['Custom Order Text']
  var PreOrderText = variantOther['Pre-Order Text']
  var isPreOrder = variantOther['Is Pre-Order']


  var imageDiv = document.getElementById("itemImage--" + productID)
  var firstVariantIMGsrc = imageDiv.children[0].src
  var firstVariantIMGalt = imageDiv.children[0].alt
  if (variantDetails['featured_image']) {
    var variantIMGsrc = variantDetails['featured_image']['src']
    var variantIMGalt = variantDetails['featured_image']['alt']
  }

  //handles price changes and badge change
  if (priceDiv) { //price
    priceDiv.innerText = '$' + ((variantPrice / 100).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (variantComparedPrice) { //adjust elements if there is a compare price
      priceDiv.classList.add('price--highlight')
      if (comparePriceDiv) { //compared price
        comparePriceDiv.innerText = '$' + ((variantComparedPrice / 100).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      if (badgeSale) { //adds savings label
        badgeSale.innerText = variantSavings
      } else {
        var saleBadge = document.createElement('span')
        saleBadge.classList.add('product-label')
        saleBadge.classList.add('product-label--custom2')
        saleBadge.id = `product-labels-on-sale--${productID}`
        saleBadge.innerText = variantSavings
        badgeContainer.appendChild(saleBadge)
      }
    } else { //change elements if no compare price
      priceDiv.classList.remove('price--highlight')
      if (comparePriceDiv) { //removes compare at price
        comparePriceDiv.innerText = ''
      }
      if (badgeSale) {  //removes sale label
        badgeSale.remove()
      }
    }
  }

  //handles bulk buy change
  if (document.getElementById(`case-size--${productID}`)) {
    document.getElementById(`case-size--${productID}`).value = caseQty
  }

  //handles badge change (discontinued/clearance etc.)
  if (deals.includes('Discontinued')) {//look at deals and add the appropriate badge
    if (!badgeDisc) {
      var DiscBadge = document.createElement('span')
      DiscBadge.classList.add('product-label')
      DiscBadge.classList.add('product-label--custom2')
      DiscBadge.id = `product-labels-disc--${productID}`
      DiscBadge.innerText = discLabel
      badgeSpecialContainer.appendChild(DiscBadge)
    }
  } else if (deals.includes('Clearance')) {
    if (!badgeClear) {
      var ClearBadge = document.createElement('span')
      ClearBadge.classList.add('product-label')
      ClearBadge.classList.add('product-label--custom3')
      ClearBadge.id = `product-labels-clear--${productID}`
      ClearBadge.innerText = clearLabel
      badgeSpecialContainer.appendChild(ClearBadge)
    }
  } else if (deals.includes('Limited')) {
    if (!badgeLimted) {
      var LimtedBadge = document.createElement('span')
      LimtedBadge.classList.add('product-label')
      LimtedBadge.classList.add('product-label--custom4')
      LimtedBadge.id = `product-labels-limted--${productID}`
      LimtedBadge.innerText = limtedLabel
      badgeSpecialContainer.appendChild(LimtedBadge)
    }
  } else {
    if (document.getElementById(`product-labels-disc--${productID}`)) {
      document.getElementById(`product-labels-disc--${productID}`).remove()
    }
    if (document.getElementById(`product-labels-clear--${productID}`)) {
      document.getElementById(`product-labels-clear--${productID}`).remove()
    }
    if (document.getElementById(`product-labels-limted--${productID}`)) {
      document.getElementById(`product-labels-limted--${productID}`).remove()
    }

  }

  //handles variant stock avabailabilies and button changes

  if (variantInventoryNumber > 0 && buyButton !== null) {
    buyButton.disabled = false;

    if (PreOrder === true) {
      buyButton.innerText = CustomPreLabel
      customOrderPreInfo.innerText = PreOrderText
    } else if (CustomOrder) {
      buyButton.innerText = CustomOrderLabel
      customOrderPreInfo.innerText = CustomOrderText
    } else {
      buyButton.innerText = AddToCartLabel
      customOrderPreInfo.innerText = ''
    }
    buyButton.classList.remove("button--disabled")
    buyButton.classList.add("button--primary")
    checkExDiv.innerHTML = checkSVG
  } else if (buyButton !== null) {
    buyButton.disabled = true;
    buyButton.innerText = SoldOutLabel
    customOrderPreInfo.innerText = ''
    buyButton.classList.add("button--disabled")
    buyButton.classList.remove("button--primary")
    checkExDiv.innerHTML = exSVG
  }
  if (PreOrder === true && storeNameDiv !== null) {
    storeNameDiv.innerText = CustomPreLabel
  } else if (CustomOrder && storeNameDiv !== null) {
    storeNameDiv.innerText = CustomOrderLabel
  } else if (storeNameDiv !== null) {
    if (my_store === 'warehouse') {
      storeNameDiv.innerText = itemInventoryLocales['delivery']
    } else {
      storeNameDiv.innerText = itemInventoryLocales['pickup_at'] + " " + my_storeName
    }
  }

  //handles variant images change
  if (variantIMGsrc) {
    imageDiv.innerHTML = `<img src="${variantIMGsrc}&width=400" alt="${variantIMGalt}" width="600" height="600" loading="lazy" sizes="(max-width: 699px) 100vw, 600px" data-media-id="6349040943183" class="product-item__primary-image"><img src="${firstVariantIMGsrc}&width=400" alt="${firstVariantIMGalt}" width="600" height="600" loading="lazy" sizes="(max-width: 699px) 100vw, 600px" class="product-item__secondary-image">`
  }

  //handles manufacting info vhange

  var manuInfo = variantOther['Manufacturing Info']
  var warningContainer = document.getElementById(`warningContainer--${productID}`)
  var warningAlertText = document.getElementById(`warningAlertText--${productID}`)
  var warningText = document.getElementById(`warningText--${productID}`)

  if (manuInfo) {
    warningText.innerHTML = manuInfo
    if (warningContainer.style.display = 'none') {
      warningContainer.style.display = 'block'
    }
  } else {
    if (warningContainer.style.display = 'block') {
      warningContainer.style.display = 'none'
    }
  }


}

//this function also exists in product-item.liquid
function setExpectedDate(sku, target, inventoryNumber, type){
  //Expected Arrival PO DATE
  var expectedDelivery = document.getElementById(`${target}`)
  if (inventoryNumber < 1 && expectedDelivery) {
    expectedDelivery.innerHTML = `Expected${type === 'page'? ' Arrival' : ''}: ${loader}`
    setTimeout(
      getExpectedDateBySKU(sku)
        .then(expectedDate => {
          expectedDelivery.innerHTML = `Expected${type === 'page'? ' Arrival' : ''}: ${expectedDate === null? 'TBD': expectedDate}`
        })
      ,1000
    )
  } else if(expectedDelivery) {
    expectedDelivery.innerHTML = ``
  }
}

function deleteCartItem(x) {
  var cartItems = localStorage.getItem('cartItems')
  cartItems = JSON.parse(cartItems)
  delete cartItems[x]
  localStorage.setItem('cartItems', JSON.stringify(cartItems))
}

function cartVerifyModal(x, y) {
  var cartTotal = parseInt(y)
  var adjustedPrice = cartTotal
  if (x) {
    var myStore = x
  } else {
    var myStore = my_store
  }

  var buttonContainer = document.getElementById('buttonContainer')

  //table
  var cartItems = localStorage.getItem('cartItems')
  cartItems = JSON.parse(cartItems)
  console.log(cartItems)
  var cartVerifyTable = document.getElementById("cartVerifyTable")
  if (cartVerifyTable.style.display === 'none') {
    cartVerifyTable.style.display = 'table'
  }
  //document.getElementById("storeList").style.display = 'none'
  var cartVerifytBody = document.getElementById("cartVerifytBody")
  cartVerifytBody.innerHTML = ''
  var checkEx = ''
  itemsFixCount = 0
  var itemsFix = {}
  itemCount = 0

  for (let x in cartItems) {
    var replacementTitle = ''
    var replacementInventory = 0
    itemCount += 1
    if (parseInt(cartItems[x]['Item Details']['quantity']) > parseInt(cartItems[x]['Inventory'][myStore])) {
      checkEx = exSVG
      itemsFix[x] = parseInt(cartItems[x]['Inventory'][myStore])
      itemsFixCount += 1
      var row = cartVerifytBody.insertRow();
      row.id = x
      cellBody = row.insertCell()
      cellBody.innerHTML = checkEx
      cellHead = row.insertCell()
      cellHead.innerHTML = cartItems[x]['Item Details']['title']
      adjustedPrice = adjustedPrice - (parseFloat(cartItems[x]['Item Details']['price']) * (parseInt(cartItems[x]['Item Details']['quantity']) - parseInt(cartItems[x]['Inventory'][myStore])))
      cellBody = row.insertCell()
      cellBody.classList.add('table__cell--center')
      cellBody.innerHTML = parseInt(cartItems[x]['Item Details']['quantity'])
      cellBody = row.insertCell()
      cellBody.classList.add('table__cell--center')
      cellBody.innerHTML = parseInt(cartItems[x]['Inventory'][myStore])
      var replacements = cartItems[x]['Other Variants']
      for (let y in replacements) {
        if (y !== x) {
          replacementTitle = replacements[y]['Variant Details']['title']
          replacementInventory = replacements[y]['Inventory Details'][myStore]
          replacementID = replacements[y]['Variant Details']['id']
          replacementPrice = parseFloat(replacements[y]['Variant Details']['price']) / 100
          if (replacementInventory > 0 && !cartItems[replacementID]) {
            var row = cartVerifytBody.insertRow();
            row.id = y
            row.style.borderTop = 'none'
            var cellHeading = row.insertCell()
            cellHeading.classList.add('heading')
            cellHeading.innerHTML = `${replacementTitle} available, Replace? <button class="button" type=button onclick="changeInputNumberVerify(this.id,'${replacementInventory}',${x},${replacementPrice})" id="minus--${replacementID}">&minus;</button><input type="number" id="quantity--${replacementID}" class="quantity-selector__value" style="width:5px" inputmode="numeric" value="0" min="0" max="${replacementInventory}" size="3"><button class="button" type=button onclick="changeInputNumberVerify(this.id,'${replacementInventory}',${x},${replacementPrice})" id="plus--${replacementID}">&plus;</button>`
          }
        }
      }
    } else {
      checkEx = checkSVG
      itemsFix[x] = parseInt(cartItems[x]['Item Details']['quantity'])
    }
  }
  window.timeout = 100 * (itemCount)
  if (timeout < 1000) {
    window.timeout = 1000
  } else if (timeout > 6000) {
    window.timeout = 6000
  }
  if (itemsFixCount > 0) {
    document.getElementById("cart_verification").ariaHidden = "false";
  } else {
    document.getElementById("checkoutButton").click();
  }
  window.itemsFix = itemsFix
  console.log(itemsFix)
  document.getElementById("oldTotal").innerHTML = `$${((cartTotal) / 100).toFixed(2)}`
  document.getElementById("newTotal").innerHTML = `$${((adjustedPrice) / 100).toFixed(2)}`
}


function changeInputNumberVerify(x, y, z, a) {
  var itemPrice = a
  itemPrice = parseFloat(itemPrice)
  var newTotal = document.getElementById('newTotal')
  newTotalValue = newTotal.innerHTML
  newTotalValue = newTotalValue.replace("$", "")
  newTotalValue = parseFloat(newTotalValue)
  //delete itemsFix[z]
  max = parseInt(y)
  var input = document.getElementById(x.replace("minus", "quantity").replace("plus", "quantity"))
  var inputValue = input.value
  inputValue = parseInt(inputValue)
  if (x.includes('minus')) {
    if (inputValue > 0) {
      input.value = inputValue - 1
      itemsFix[parseInt((input.id).replace("quantity--", ""))] = inputValue - 1
      newTotalValue = newTotalValue - (itemPrice)
    }
  } else {
    if (inputValue <= (max - 1)) {
      input.value = inputValue + 1
      itemsFix[parseInt((input.id).replace("quantity--", ""))] = inputValue + 1
      newTotalValue = newTotalValue + (itemPrice)
    }
  }
  newTotalValue = newTotalValue.toFixed(2)
  newTotal.innerHTML = `$${newTotalValue}`
}

function loaderIcon(x) {
  x.innerHTML = loader
}


function fixCart() {
  document.getElementById('fixCartButton').innerHTML = loader
  itemsFix = JSON.stringify(itemsFix)
  itemsFix = '{ "updates": ' + itemsFix + '}'
  itemsFix = JSON.parse(itemsFix)
  console.log(itemsFix)
  jQuery.ajax({
    type: 'POST',
    url: window.Shopify.routes.root + 'cart/update.js',
    data: itemsFix,
    dataType: 'json'
  }
  );
  setTimeout(checkout, timeout)
}

function checkout() {
  document.getElementById("checkoutButton").click()
}


function updateItems(x, y, z, a, b) {
  var itemID = x
  var adjustType = y
  var quantity = z
  var button = a
  var specialQTY = b
  var cartItems = localStorage.getItem('cartItems')
  cartItems = JSON.parse(cartItems)
  if (adjustType === 'change') {
    cartItems[itemID]['Item Details']['quantity'] = quantity
  } else if (adjustType === 'increase') {
    if (specialQTY) {
      var newQuantity = specialQTY
      newQuantity = parseInt(newQuantity)
    } else {
      var newQuantity = button.previousElementSibling.value
      newQuantity = parseInt(newQuantity) + 1
    }
    cartItems[itemID]['Item Details']['quantity'] = newQuantity
  } else if (adjustType === 'remove') {
    delete cartItems[itemID];
  } else if (adjustType === 'decrease') {
    if (specialQTY) {
      var newQuantity = specialQTY
      newQuantity = parseInt(newQuantity)
    } else {
      var newQuantity = button.nextElementSibling.value
      newQuantity = parseInt(newQuantity) - 1
    }
    cartItems[itemID]['Item Details']['quantity'] = newQuantity
  }
  localStorage.setItem('cartItems', JSON.stringify(cartItems))

}


window.onload = function () {
  switchCustomeritem(localStorage.getItem('customerDisplay'), 'noRedirect')
  var reloading = sessionStorage.getItem("reloading");
  if (reloading) {
    if (reloading === 'cartVerifyModal') {
      sessionStorage.removeItem("reloading");
      document.getElementById("checkout").click();
    }
  }
}

function reloadP(x) {
  sessionStorage.setItem("reloading", x);
  document.location.reload();
}

function closeModal(x) {
  var modal = document.getElementById(x)
  modal.ariaHidden = 'true'
}

function initalCartLoad() {
  var shippingLocations = localStorage.getItem('shippingLocations')
  shippingLocations = JSON.parse(shippingLocations)
  var cartItems = localStorage.getItem('cartItems')
  cartItems = JSON.parse(cartItems)
  var jsonCartLocationsResults = {}
  for (let y in shippingLocations) {
    var inStockCount = 0
    for (let x in cartItems) {
      if (cartItems[x]['Inventory'][shippingLocations[y]] | cartItems[x]['Inventory'][shippingLocations[y]] > 0) {
        inStockCount += 1
      }
    }
    jsonCartLocationsResults[shippingLocations[y]] = inStockCount
  }


}

function changeSVGColor(x, y) {
  var names = document.getElementsByName(x)
  var color = y
  if (color === '#000000') {
    color = '#272727'
  }
  for (let i = 0; i < names.length; i++) {
    names[i].style.fill = color;
  }
}

function showItems() {
  var showWJava = document.getElementsByName("showWJava")
  for (let i = 0; i < showWJava.length; i++) {
    if (showWJava[i].style.display = 'none') {
      showWJava[i].style.display = 'block'
    }
  }
}

showItems()

//this function also exists in product-item.liquid
async function getExpectedDateBySKU(sku) {
  const fetchUrl = 'https://stocky.shopifyapps.com/api/v2/purchase_orders.json';
  const storeName = 'canwest-esthetics.myshopify.com';
  const apiKey = '9020f132bedf6554c14012eec4389e1e';

  const headers = new Headers({
    'Store-Name': storeName,
    'Authorization': `API KEY=${apiKey}`
  });

  const requestOptions = {
    method: 'GET',
    headers: headers
  };

  try {
    const response = await fetch(fetchUrl, requestOptions)
    const data = await response.json()
    // Process the received data
    const purchaseOrder = data.purchase_orders.find((purchaseOrder_1) => {
      const purchaseItem = purchaseOrder_1.purchase_items.find((purchaseItem_1) => {
        return purchaseItem_1.sku === sku && purchaseItem_1.received_at === null
      })
      return purchaseItem !== undefined
    })
    return purchaseOrder ? purchaseOrder.expected_on : null
  } catch (error) {
  }
}